<div class="grid">
    <div class="col-12 md:col-2 lg:col-2 sm:col-6">
      <label for="productid" class="bold-red-text">Product</label>
      <p-dropdown 
      [options]="productList" 
      [(ngModel)]="filterinput.tproduct" 
      optionLabel="labelname"
      optionValue="value" 
      styleClass="fixed-width-dropdown-filter" 
      (onChange)="onFilterSelect(filterinput,'Product',$event)"
      inputId="productid" 
      pTooltip="{{ getTooltip(filterinput.tproduct, productList) }}"
      placeholder="Select"
      [filter]="true" 
      appendTo="body" 
      [resetFilterOnHide]="true" 
      [showClear]="true">
      </p-dropdown>
    </div>
  
    <div class="col-12 md:col-2 lg:col-2 sm:col-6">
      <label for="versionid" class="bold-red-text">Version</label>
      <p-dropdown 
      [options]="versionList" 
      [(ngModel)]="filterinput.tversionid" 
      optionLabel="labelname"
      optionValue="value" 
      styleClass="fixed-width-dropdown-filter" 
      (onChange)="onFilterSelect(filterinput,'Version',$event)"
      inputId="versionid" 
      pTooltip="{{ getTooltip(filterinput.tversionid, versionList) }}"
      placeholder="Select"
      [filter]="true" 
      appendTo="body" 
      [resetFilterOnHide]="true" 
      [showClear]="true">
      </p-dropdown>
    </div>
  
    <div class="col-12 md:col-2 lg:col-2 sm:col-6">
        <label for="categoryid" class="bold-red-text">Category</label>
        <p-dropdown 
        [options]="categoryList" 
        [(ngModel)]="filterinput.tcategory" 
        optionLabel="labelname"
        optionValue="value" 
        styleClass="fixed-width-dropdown-filter" 
        (onChange)="onFilterSelect(filterinput,'Category',$event)"
        inputId="categoryid" 
        name="categoryid" 
        pTooltip="{{ getTooltip(filterinput.tcategory, categoryList) }}"
        placeholder="Select"
        [filter]="true" 
        appendTo="body" 
        [resetFilterOnHide]="true" 
        [showClear]="true">
        </p-dropdown>
      </div>
      
      <div class="col-12 md:col-2 lg:col-2 sm:col-12"><label for="fromdate" class="bold-red-text">From Date<br/></label>
        <p-calendar  
          [showIcon]="true" 
          [pTooltip]="getfromdatetooltip()"
          [(ngModel)] ="filterinput.tfromdate" 
          placeholder="Choose Date"  
          dateFormat="dd-M-yy" 
          [readonlyInput]="true" 
          styleClass="pcalendar-readonly"
          (onSelect)="getdates(filterinput)" 
          (onClearClick)="onclear(filterinput)" 
          inputId="fromdate" 
          [showButtonBar]="true" 
          [showOtherMonths]="true"
          [selectOtherMonths]="true"    
          [showButtonBar]="true" 
          [clearButtonStyleClass]="'hideClearButton'" 
          appendTo="body">
        </p-calendar>
        
       </div>
       
       <div class="col-12 md:col-2 lg:col-2 sm:col-6"> <label for="todate" class="bold-red-text"s>To Date<br/></label>
          <p-calendar 
          [pTooltip]="gettodatetooltip()"
          [showIcon]="true"  
          [(ngModel)] ="filterinput.ttodate" 
          placeholder="Choose Date" 
          [readonlyInput]="true" 
          styleClass="pcalendar-readonly"
          dateFormat="dd-M-yy" 
          (onSelect)="getdates(filterinput)" 
          (onClearClick)="onclear(filterinput)" 
          inputId="todate" 
          [showButtonBar]="true" 
          [showOtherMonths]="true"
          [selectOtherMonths]="true"    
          [showButtonBar]="true" 
          [clearButtonStyleClass]="'hideClearButton'" 
          appendTo="body">
        </p-calendar>
          <span *ngIf="errorDIsplay" style="color: red;"><br/>To date should be greater then from date</span>
          <span *ngIf="showToDateRequired" style="color: red;"><br/>Please select To Date</span>
        </div>
          
  </div>  
  